import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { AreaState } from "./types";

export const initialAreaState: AreaState = {
  selectedFranchise: undefined,
};

export const { actions: areaActions, reducer: areaReducer } = createSlice({
  name: "area",
  initialState: initialAreaState,
  reducers: {
    selectedFranchiseChanged: (
      state,
      action: PayloadAction<AreaState["selectedFranchise"]>,
    ) => {
      state.selectedFranchise = action.payload;
    },
  },
});
